export const articles = [
  {
    id: 1,
    title: '2024年最值得期待的十部好莱坞科幻大片',
    slug: '2024-hollywood-sci-fi-must-watch',
    category: 'sci-fi',
    categoryName: '科幻巨制',
    excerpt: '从《沙丘2》到《猩球崛起4》，2024年好莱坞科幻大片阵容堪称豪华。本文为你盘点今年最值得期待的十部科幻巨制，每一部都值得走进影院。',
    content: `
      <p>2024年对于科幻影迷来说注定是丰收的一年。从经典IP续作到全新原创故事，好莱坞各大制片厂纷纷拿出重磅作品。本文将为你全面盘点今年最值得期待的十部科幻大片。</p>

      <h2>1. 沙丘2（Dune: Part Two）</h2>
      <p>丹尼斯·维伦纽瓦执导的《沙丘》续集无疑是今年最受瞩目的科幻电影。保罗·厄崔迪与弗雷曼人并肩作战，向摧毁他家族的阴谋者展开复仇。影片延续了第一部的宏大视觉风格，动作场面更上一层楼。提莫西·查拉梅、赞达亚、奥斯汀·巴特勒等全明星阵容令人期待。</p>

      <h2>2. 猩球崛起4：新世界</h2>
      <p>故事设定在凯撒逝世300年后，猿类已成为地球的主宰物种，而人类则退化为原始状态。一只年轻的猩猩踏上了质疑自己所知一切的旅程，这将影响猩猩和人类的未来。这部作品将《猩球崛起》系列带入了一个全新的时代。</p>

      <h2>3. 哥斯拉大战金刚2：帝国崛起</h2>
      <p>继前作史诗对决后，哥斯拉与金刚再度联手，面对一个潜伏在地心世界的神秘巨大威胁。这部续集将怪兽宇宙的规模提升到了前所未有的高度，特效场面令人瞠目结舌。</p>

      <h2>4. 疯狂的麦克斯：狂暴女神</h2>
      <p>乔治·米勒回归执导，《狂暴女神》是《疯狂的麦克斯：狂暴之路》的前传，聚焦年轻弗瑞奥萨的起源故事。安雅·泰勒-乔伊接棒查理兹·塞隆，与克里斯·海姆斯沃斯饰演的反派展开对决。</p>

      <h2>5. 米奇17号</h2>
      <p>奉俊昊继《寄生虫》后首部作品，改编自爱德华·阿什顿的科幻小说。罗伯特·帕丁森饰演一名被称为"消耗品"的复制人，被派去殖民冰冻星球。每次他死亡都会以新身体复活，直到某天两个版本的自己同时存在。</p>

      <h2>6. 异形：罗慕路斯</h2>
      <p>费德·阿尔瓦雷兹执导的《异形》系列新作，故事设定在第一部和第二部之间。一群年轻的太空殖民者在废弃空间站中遭遇了宇宙中最恐怖的生命体。这部作品承诺回归系列的恐怖根源。</p>

      <h2>7. 寂静之地：入侵日</h2>
      <p>这部前传将带观众回到外星生物入侵的第一天，展现这场末日浩劫的开端。露皮塔·尼永奥主演，故事发生在纽约市，为这个成功的恐怖科幻系列揭开全新的篇章。</p>

      <h2>8. 变形金刚：起源</h2>
      <p>这部动画电影将讲述擎天柱和威震天在赛博坦星球的起源故事，揭示这对宿敌如何从兄弟变成死敌。克里斯·海姆斯沃斯和布莱恩·泰里·亨利领衔豪华配音阵容。</p>

      <h2>9. 无中生友</h2>
      <p>约翰·卡拉辛斯基执导的奇幻喜剧，讲述一个女孩发现自己能看到所有人的"幻想朋友"，并踏上了一场冒险之旅。瑞安·雷诺兹主演，影片融合了科幻想象与温暖情感。</p>

      <h2>10. 电幻国度</h2>
      <p>罗素兄弟执导，改编自同名图像小说。米莉·波比·布朗饰演一名少女，在一个机器人横行的复古未来主义世界中寻找失踪的弟弟。影片视觉风格独特，融合了科幻与公路电影元素。</p>

      <p>以上十部科幻大片各具特色，从史诗级太空歌剧到末日生存惊悚，能满足不同类型科幻影迷的需求。你最期待哪一部呢？</p>
    `,
    date: '2024-03-15',
    author: '影评人小李',
    image: 'https://readdy.ai/api/search-image?query=2024%20Hollywood%20science%20fiction%20movie%20collage%2C%20futuristic%20cinematic%20atmosphere%2C%20spaceships%20and%20alien%20planets%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20warm%20golden%20and%20deep%20space%20tones%2C%20movie%20poster%20style%20composition&width=1200&height=630&seq=article-sci-fi-2024&orientation=landscape',
    tags: ['2024电影', '科幻大片', '好莱坞', '观影指南'],
  },
  {
    id: 2,
    title: '诺兰电影宇宙：从《记忆碎片》到《奥本海默》的叙事革命',
    slug: 'nolan-film-universe-narrative-revolution',
    category: 'drama',
    categoryName: '经典剧情',
    excerpt: '克里斯托弗·诺兰是好莱坞最具作者风格的导演之一。从早期的《记忆碎片》到最新的《奥本海默》，他用独特的非线性叙事改写了商业电影的语法。',
    content: `
      <p>克里斯托弗·诺兰，这个名字在当代电影界几乎等同于"烧脑"和"视觉奇观"。作为好莱坞最具作者风格的导演之一，他成功地在商业大片与艺术表达之间找到了独特的平衡点。本文将回顾诺兰的导演生涯，探索他如何用非线性叙事改写了商业电影的语法。</p>

      <h2>早期探索：低成本中的叙事野心</h2>
      <p>诺兰的处女作《追随》（1998）仅用6000美元预算拍摄完成。这部黑白片讲述了一个作家追踪陌生人的故事，采用破碎的时间线结构。尽管制作简陋，但诺兰标志性的叙事风格已经初现端倪。</p>
      <p>2000年的《记忆碎片》真正让诺兰声名鹊起。影片采用双线叙事——黑白画面正序讲述，彩色画面倒序讲述——两条线索在片尾交汇，带给观众前所未有的观影体验。这部电影确立了诺兰作为"叙事魔术师"的地位。</p>

      <h2>蝙蝠侠三部曲：重新定义超级英雄类型</h2>
      <p>2005年，诺兰接手《蝙蝠侠：侠影之谜》，用现实主义手法重塑了这个经典超级英雄。他摒弃了漫画式的夸张风格，将蝙蝠侠放置在一个可信的现代都市中。2008年的《黑暗骑士》更是将超级英雄片提升到了犯罪史诗的高度，希斯·莱杰的小丑成为影史经典反派。2012年的《黑暗骑士崛起》为三部曲画上了圆满的句号。</p>

      <h2>原创巅峰：梦境与太空的叙事奇观</h2>
      <p>2010年的《盗梦空间》是诺兰原创能力的巅峰展示。影片构建了层层嵌套的梦境结构，将抢劫片类型与心理学探讨完美融合。旋转走廊的打斗戏至今令人叹为观止。</p>
      <p>2014年的《星际穿越》则是一次情感与科学的结合。诺兰邀请诺贝尔物理学奖得主基普·索恩担任科学顾问，确保片中黑洞、虫洞的呈现符合科学原理。而影片的核心却是库珀与女儿墨菲之间穿越时空的父女之情。</p>

      <h2>历史重构：《敦刻尔克》与《奥本海默》</h2>
      <p>2017年的《敦刻尔克》标志着诺兰转向历史题材。影片以海陆空三线并行的方式叙述敦刻尔克大撤退，将时间作为核心叙事元素——三条线的时间跨度不同，但最终在影片高潮处交汇。</p>
      <p>2023年的《奥本海默》则达到了诺兰创作生涯的新高度。影片采用彩色（奥本海默视角）和黑白（施特劳斯视角）双线叙事，深入探讨了"原子弹之父"的内心世界和历史责任。希里安·墨菲贡献了职业生涯最佳表演。</p>

      <h2>诺兰的叙事密码</h2>
      <p>纵观诺兰的电影作品，我们可以发现几个贯穿始终的叙事特征：非线性时间结构、多层嵌套叙事、高概念设定、以及情感核心的坚守。诺兰证明了一部电影可以同时具备智力挑战性和情感打动力。</p>
      <p>从独立电影人到商业大片导演，诺兰走出了一条独特的创作之路。他用电影证明：观众远比好莱坞高管想象的更聪明。</p>
    `,
    date: '2024-02-28',
    author: '资深影迷老王',
    image: 'https://readdy.ai/api/search-image?query=Christopher%20Nolan%20film%20director%20retrospective%2C%20movie%20film%20reels%20and%20clapperboard%2C%20cinematic%20lighting%2C%20film%20set%20atmosphere%2C%20warm%20golden%20tones%2C%20classic%20hollywood%20aesthetic%2C%20artistic%20composition&width=1200&height=630&seq=article-nolan&orientation=landscape',
    tags: ['诺兰', '导演研究', '叙事结构', '经典回顾'],
  },
  {
    id: 3,
    title: '悬疑片爱好者的终极片单：十部高智商烧脑电影推荐',
    slug: 'top-10-mind-bending-thriller-movies',
    category: 'thriller',
    categoryName: '悬疑惊悚',
    excerpt: '如果你喜欢在观影过程中不断被反转震撼，那么这份悬疑惊悚片单就是为你准备的。从大卫·芬奇的《七宗罪》到丹尼斯·维伦纽瓦的《囚徒》，每一部都是顶级烧脑体验。',
    content: `
      <p>悬疑惊悚片是检验一部电影叙事能力的试金石。优秀的悬疑片能让观众在观影过程中不断思考、猜测，直到最后一刻才恍然大悟。以下十部高智商烧脑电影，每一部都值得反复品味。</p>

      <h2>1. 七宗罪（Se7en）- 1995</h2>
      <p>大卫·芬奇的黑暗杰作。即将退休的警探萨默塞特与新调来的年轻警探米尔斯联手追查一名以天主教七宗罪为杀人动机的连环杀手。影片的氛围营造堪称教科书级别，结局更是影史最令人震撼的反转之一。</p>

      <h2>2. 致命ID（Identity）- 2003</h2>
      <p>一个暴风雨之夜，十一个陌生人被困在一家汽车旅馆。他们一个接一个地离奇死亡，每个人身上都带着一个数字。这部电影的结局会让你重新思考之前看到的一切。詹姆斯·曼高德精准的叙事控制令人赞叹。</p>

      <h2>3. 禁闭岛（Shutter Island）- 2010</h2>
      <p>马丁·斯科塞斯执导的心理惊悚片。联邦警探泰迪来到禁闭岛精神病院调查一桩失踪案，但随着调查深入，他发现这座岛上隐藏着不可告人的秘密。莱昂纳多·迪卡普里奥的精湛演技让观众始终处于不确定之中。</p>

      <h2>4. 囚徒（Prisoners）- 2013</h2>
      <p>丹尼斯·维伦纽瓦执导的这部作品讲述了两个小女孩失踪后，父亲凯勒不顾一切寻找女儿的故事。休·杰克曼和杰克·吉伦哈尔的对手戏张力十足，影片对正义与道德的探讨发人深省。</p>

      <h2>5. 看不见的客人（Contratiempo）- 2016</h2>
      <p>西班牙导演奥里奥尔·保罗的悬疑杰作。成功商人阿德里安被指控谋杀情人，他在开庭前请来最好的律师为自己辩护。随着两人的对话展开，真相一次次被推翻重组。这部电影的叙事技巧堪称完美，不到最后一刻你永远不知道真相。</p>

      <h2>6. 消失的爱人（Gone Girl）- 2014</h2>
      <p>大卫·芬奇改编自吉莉安·弗琳同名小说的作品。在结婚五周年纪念日，妻子艾米失踪了，丈夫尼克成为了头号嫌疑人。本·阿弗莱克和罗莎曼德·派克的表演令人不寒而栗，影片对婚姻本质的剖析尖锐入骨。</p>

      <h2>7. 源代码（Source Code）- 2011</h2>
      <p>邓肯·琼斯执导的科幻悬疑片。士兵科尔特不断被送回一列即将爆炸的火车上的最后八分钟，他必须在有限时间内找出炸弹客的身份。紧凑的节奏和温暖的结局让这部烧脑电影多了一份情感温度。</p>

      <h2>8. 记忆碎片（Memento）- 2000</h2>
      <p>克里斯托弗·诺兰的成名作。患有短期记忆丧失的莱纳德通过纹身和照片追寻杀害妻子的凶手。影片采用独特的倒叙结构，让观众亲身体验主角的记忆困境。这是诺兰叙事天才的最早展现。</p>

      <h2>9. 穆赫兰道（Mulholland Drive）- 2001</h2>
      <p>大卫·林奇的梦境之作。一个失忆女子和一个怀揣好莱坞梦想的女孩的命运交织在一起。影片如梦境般流动，现实与幻觉的边界模糊不清。它被誉为21世纪最伟大的电影之一，也是一道需要反复解读的谜题。</p>

      <h2>10. 调音师（Andhadhun）- 2018</h2>
      <p>这部印度悬疑片讲述了假装盲人的钢琴调音师意外卷入一桩谋杀案的故事。影片充满黑色幽默，剧情反转多达五十余次，让人目不暇接。它用轻松的方式讲述了最暗黑的故事，是近年悬疑片的一大惊喜。</p>

      <p>观看这些电影最好的方式，就是不要提前看任何剧透。关掉手机，调暗灯光，准备好被这些高智商叙事征服吧。</p>
    `,
    date: '2024-03-08',
    author: '影评人小李',
    image: 'https://readdy.ai/api/search-image?query=psychological%20thriller%20movie%20theme%2C%20dark%20mysterious%20atmosphere%2C%20magnifying%20glass%20over%20film%20noir%20scene%2C%20dramatic%20shadows%2C%20cinematic%20composition%2C%20deep%20red%20and%20black%20tones%2C%20mystery%20suspense%20aesthetic&width=1200&height=630&seq=article-thriller&orientation=landscape',
    tags: ['悬疑片', '烧脑电影', '反转结局', '观影推荐'],
  },
  {
    id: 4,
    title: 'IMDb Top 250深度解析：那些稳居神坛的欧美经典电影',
    slug: 'imdb-top-250-classic-analysis',
    category: 'drama',
    categoryName: '经典剧情',
    excerpt: 'IMDb Top 250是全球影迷公认的电影圣经。从《肖申克的救赎》到《教父》，这些稳居榜单前列的电影到底有什么过人之处？让我们一探究竟。',
    content: `
      <p>IMDb Top 250榜单是全球影迷衡量电影品质的重要参考。这个基于数百万用户评分的榜单，汇集了电影史上最受认可的作品。今天我们来深度解析榜单前十名的经典之作。</p>

      <h2>第一名：《肖申克的救赎》（1994）- 评分9.3</h2>
      <p>弗兰克·德拉邦特执导的这部电影，讲述了一个关于希望、友谊和自由的监狱故事。蒂姆·罗宾斯和摩根·弗里曼的表演堪称完美。影片之所以能稳居榜首，在于它触及了人类最普遍的情感——即使在最黑暗的时刻，希望依然可以照亮前路。</p>

      <h2>第二名：《教父》（1972）- 评分9.2</h2>
      <p>科波拉将马里奥·普佐的黑帮小说改编成了一部关于家庭、权力和美国梦的史诗。马龙·白兰度和阿尔·帕西诺塑造了影史最经典的人物形象。影片超越黑帮类型，成为了一部探讨人性本质的艺术杰作。</p>

      <h2>第三名：《黑暗骑士》（2008）- 评分9.0</h2>
      <p>诺兰将超级英雄电影提升到了前所未有的高度。希斯·莱杰的小丑表演定义了"混乱"这个词。影片不仅是一场视觉盛宴，更是对秩序与混乱、英雄与反英雄的深刻哲学探讨。</p>

      <h2>第四名：《教父2》（1974）- 评分9.0</h2>
      <p>作为续集超越前作的罕见范例，双线叙事——维托·柯里昂的崛起和迈克尔的堕落——构成了完美的对称结构。罗伯特·德尼罗凭借此片获得奥斯卡最佳男配角。</p>

      <h2>第五名：《十二怒汉》（1957）- 评分9.0</h2>
      <p>西德尼·吕美特的这部作品几乎全片发生在一间陪审团室内，却创造了电影史上最紧张的戏剧冲突。十二个男人的对话揭示了偏见、理性和正义的本质。它证明了伟大的电影不需要大场面。</p>

      <h2>第六名：《辛德勒的名单》（1993）- 评分9.0</h2>
      <p>斯皮尔伯格用黑白影像记录了二战期间德国商人辛德勒拯救一千多名犹太人的真实故事。连姆·尼森、本·金斯利和拉尔夫·费因斯的表演令人心碎。影片的黑白画面中那抹红衣，成为影史最震撼的视觉符号之一。</p>

      <h2>第七名：《指环王3：王者无敌》（2003）- 评分9.0</h2>
      <p>彼得·杰克逊的中土史诗三部曲以这部横扫11项奥斯卡奖的终章完美收官。影片将奇幻文学改编提升到了史诗级别，证明了类型片同样可以取得艺术与商业的双重巅峰。</p>

      <h2>第八名：《低俗小说》（1994）- 评分8.9</h2>
      <p>昆汀·塔伦蒂诺的环状叙事杰作彻底改变了独立电影的格局。非线性叙事、精彩的对话和对流行文化的致敬，让这部影片成为了90年代最具影响力的电影之一。</p>

      <h2>第九名：《指环王1：护戒使者》（2001）- 评分8.9</h2>
      <p>作为三部曲的开篇，这部作品成功地将托尔金宏大的中土世界呈现在大银幕上。新西兰的壮丽风光与霍华德·肖的配乐相得益彰，为后续的奇幻电影树立了标杆。</p>

      <h2>第十名：《黄金三镖客》（1966）- 评分8.8</h2>
      <p>赛尔乔·莱昂内的意大利式西部片巅峰之作。克林特·伊斯特伍德、李·范·克里夫和埃里·瓦拉赫三人的精彩对决，配以埃尼奥·莫里康内的经典配乐，创造了西部片史上最经典的场景。</p>

      <p>这些电影之所以能稳居榜单前列，不仅因为它们的艺术成就，更因为它们触达了超越时代和文化的普遍人性。每一位电影爱好者都应该至少看过这份榜单。</p>
    `,
    date: '2024-03-01',
    author: '电影发烧友小张',
    image: 'https://readdy.ai/api/search-image?query=classic%20film%20movie%20collection%20on%20wooden%20shelf%2C%20vintage%20film%20reels%20and%20posters%2C%20warm%20golden%20cinematic%20lighting%2C%20nostalgic%20hollywood%20aesthetic%2C%20rich%20textures%2C%20classic%20movie%20memorabilia&width=1200&height=630&seq=article-imdb&orientation=landscape',
    tags: ['IMDb', '经典电影', '排行榜', '影史经典'],
  },
  {
    id: 5,
    title: '从《泰坦尼克号》到《爱乐之城》：好莱坞爱情片的进化史',
    slug: 'hollywood-romance-movie-evolution',
    category: 'romance',
    categoryName: '爱情经典',
    excerpt: '好莱坞爱情电影经历了从经典浪漫到现代现实主义的转变。本文将带你回顾那些定义了"爱情"这个词的银幕经典。',
    content: `
      <p>爱情是电影永恒的主题。从黑白默片时代的浪漫喜剧到如今的多元化爱情叙事，好莱坞爱情电影经历了翻天覆地的变化。本文将回顾那些定义了不同时代的爱情经典。</p>

      <h2>黄金时代：经典的诞生</h2>
      <p>好莱坞黄金时代的爱情电影奠定了浪漫类型的基本语法。《卡萨布兰卡》（1942）中"我们永远拥有巴黎"的台词至今令人心碎。《罗马假日》（1953）中奥黛丽·赫本和格利高里·派克的纯真爱情，定义了公主与平民的浪漫公式。《乱世佳人》（1939）则用宏大的历史背景烘托了一段刻骨铭心的爱情。</p>

      <h2>新时代浪潮：现实主义的冲击</h2>
      <p>70年代的新好莱坞运动带来了更真实、更复杂的爱情叙事。《安妮·霍尔》（1977）用自嘲式的幽默解构了浪漫关系。《毕业生》（1967）则大胆触及了禁忌之恋。</p>

      <h2>90年代：史诗浪漫的复兴</h2>
      <p>1997年的《泰坦尼克号》将爱情与灾难史诗完美结合。杰克和罗丝的故事不仅仅是一段爱情，更是对阶级、自由和生命意义的探讨。影片创下的票房纪录至今令人咋舌。</p>
      <p>同时期的《西雅图夜未眠》（1993）、《诺丁山》（1999）等浪漫喜剧则以轻松温暖的方式抚慰观众的心灵。</p>

      <h2>现代转型：多样化的爱情叙事</h2>
      <p>进入新千年后，爱情电影变得更多元。《断背山》（2005）用西部片的语境讲述了一段禁忌之恋。《她》（2013）探讨了人与人工智能之间的情感可能。《爱乐之城》（2016）则用歌舞片的形式，讲述了一个关于梦想与取舍的现代爱情故事。</p>

      <h2>爱情电影的未来</h2>
      <p>如今的好莱坞爱情电影正在经历深刻的转型。传统的浪漫公式逐渐被更复杂、更多元的关系叙事取代。不论是跨种族的爱情、同性的爱情，还是探讨数字时代亲密关系的作品，爱情电影正在以更丰富的方式反映我们这个时代。</p>

      <p>电影中的爱情故事在不断进化，但核心永远是——人与人之间的情感连接。这也许就是为什么我们永远需要爱情电影。</p>
    `,
    date: '2024-02-14',
    author: '资深影迷老王',
    image: 'https://readdy.ai/api/search-image?query=romantic%20movie%20scene%2C%20couple%20dancing%20under%20starry%20night%20sky%2C%20cinematic%20lighting%2C%20warm%20golden%20and%20pink%20tones%2C%20dreamy%20atmosphere%2C%20elegant%20hollywood%20romance%20aesthetic%2C%20soft%20focus&width=1200&height=630&seq=article-romance&orientation=landscape',
    tags: ['爱情电影', '好莱坞', '浪漫经典', '电影史'],
  },
  {
    id: 6,
    title: '动作片迷不能错过的十部硬核欧美动作大片',
    slug: 'top-10-hardcore-action-movies',
    category: 'action',
    categoryName: '动作大片',
    excerpt: '从《疯狂的麦克斯：狂暴之路》到《疾速追杀》系列，现代动作电影已经进化到了一个全新的层次。这份片单献给所有热爱肾上腺素飙升的硬核动作影迷。',
    content: `
      <p>动作电影是好莱坞最受欢迎的类型之一。近年来，随着拍摄技术和动作设计理念的进化，动作片已经远远超越了简单的爆炸和追车。以下十部硬核动作大片，代表了这一类型的最高水准。</p>

      <h2>1. 疯狂的麦克斯：狂暴之路（Mad Max: Fury Road）- 2015</h2>
      <p>乔治·米勒用两小时的持续追逐，将动作电影提升到了艺术品的高度。影片几乎全部使用实景拍摄，极少CGI特效。汤姆·哈迪和查理兹·塞隆的化学反应令人难忘。这部电影重新定义了"动作片"这个类型。</p>

      <h2>2. 疾速追杀（John Wick）- 2014</h2>
      <p>基努·里维斯饰演的退休杀手因为一只狗重出江湖。影片的动作设计融入了枪械武术和柔道元素，干净利落、行云流水。这个系列创造了一种全新的动作电影美学。</p>

      <h2>3. 谍影重重3（The Bourne Ultimatum）- 2007</h2>
      <p>保罗·格林格拉斯的晃动镜头和快速剪辑彻底改变了谍战动作片的语法。马特·达蒙的杰森·伯恩成为了最可信的银幕特工——他不是超级英雄，他只是训练有素的人类。</p>

      <h2>4. 终结者2：审判日（Terminator 2: Judgment Day）- 1991</h2>
      <p>詹姆斯·卡梅隆的这部续集在特效和动作设计上全面超越了前作。T-1000液态金属机器人的特效至今仍不过时。施瓦辛格的角色从反派变成保护者，赋予了动作英雄更深的情感维度。</p>

      <h2>5. 虎胆龙威（Die Hard）- 1988</h2>
      <p>布鲁斯·威利斯饰演的纽约警探约翰·麦克莱恩定义了一种全新的动作英雄——他不是肌肉发达的超人，而是一个会受伤、会说俏皮话的普通人。这部影片的叙事结构被无数后来者模仿。</p>

      <h2>6. 速度与激情7（Furious 7）- 2015</h2>
      <p>飞车家族的最经典篇章。影片的动作场面不断突破物理极限——飞车跳伞、摩天大楼穿越。而保罗·沃克的告别场景，让这部动作大片拥有了令人动容的情感内核。</p>

      <h2>7. 突袭（The Raid）- 2011</h2>
      <p>这部印尼动作片重新定义了近身格斗的标准。一栋大楼、一支特警队、无尽的敌人——极简的设定下是最极致的动作编排。伊科·乌艾斯的武术功底让每一场打斗都充满真实感。</p>

      <h2>8. 007：大战皇家赌场（Casino Royale）- 2006</h2>
      <p>丹尼尔·克雷格的首部007电影，用粗粝写实的风格重塑了这个经典特工形象。开场的跑酷追逐戏堪称新世纪动作电影的标杆。</p>

      <h2>9. 边境杀手（Sicario）- 2015</h2>
      <p>丹尼斯·维伦纽瓦的这部作品虽然不是传统意义上的动作片，但其中的枪战和突袭场面压迫感十足。影片将动作元素与政治惊悚完美结合。</p>

      <h2>10. 王牌特工：特工学院（Kingsman: The Secret Service）- 2014</h2>
      <p>马修·沃恩用漫画式的夸张风格致敬了经典间谍片。科林·费尔斯的教堂百人斩长镜头是近年最令人印象深刻的一段动作戏。影片在暴力美学和幽默之间找到了完美的平衡。</p>

      <p>如果你自认为是硬核动作片爱好者，这份片单里应该没有你还没看过的作品。如果有——别犹豫，立刻补上。</p>
    `,
    date: '2024-03-20',
    author: '电影发烧友小张',
    image: 'https://readdy.ai/api/search-image?query=high%20octane%20action%20movie%20scene%2C%20car%20chase%20in%20urban%20environment%2C%20explosive%20dynamic%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20orange%20and%20dark%20tones%2C%20adrenaline%20filled%20composition%2C%20movie%20poster%20style&width=1200&height=630&seq=article-action&orientation=landscape',
    tags: ['动作片', '硬核', '观影推荐', '动作设计'],
  },
];

export const getArticleById = (id: number) => {
  return articles.find((a) => a.id === id);
};

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug);
};

export const getLatestArticles = (limit: number = 4) => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, limit);
};

export const getRelatedArticles = (currentId: number, limit: number = 3) => {
  return articles.filter((a) => a.id !== currentId).slice(0, limit);
};